import { ContractModel, PriceInfoModel, BundleSkusModel } from './index';

export class SkusModel {
    contract: ContractModel;
    priceInfo: PriceInfoModel;
    otherPriceInfo: PriceInfoModel;
    description: string;
    displayName: string;
    id: string;
    socCode: string;
    tncUrl: string;
    basicPrice: string;
    skuType: string;
    moduleCount: string;
    productId: string;
    quantity: number;
    selected: number;
    isSelectedProduct: boolean;
    isSingleQuantity: string;
    bundleSkus: Array<BundleSkusModel>;
    // Default constructor will be called by mapper
    constructor() {
        this.contract = undefined;
        this.priceInfo = undefined;
        this.description = undefined;
        this.displayName = undefined;
        this.id = undefined;
        this.socCode = undefined;
        this.tncUrl = undefined;
        this.basicPrice = undefined;
        this.skuType = undefined;
        this.moduleCount = undefined;
        this.productId = undefined;
        this.quantity = undefined;
        this.selected = undefined;
        this.isSelectedProduct = false;
        this.isSingleQuantity = undefined;
        this.bundleSkus = undefined;
    }
}
